// extracted by mini-css-extract-plugin
export default {"wrapper":"ConsentPopUp_wrapper__sRG+U","title":"ConsentPopUp_title__NtJYD","text":"ConsentPopUp_text__zcKr3","btn":"ConsentPopUp_btn__XrHYj"};